import React from "react";
import { Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import { routes } from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { ChakraProvider } from '@chakra-ui/react';
import customTheme from "./utils/theme";
import store from "./redux/store";
import { IntlProvider } from "react-intl";
import { HelmetProvider } from 'react-helmet-async';
import ArabicMessages from "./locale/ar.json";
import EnglishMessages from "./locale/en.json";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const lang = JSON.parse(localStorage.getItem("lang"));

  let Language;

  if (lang) {
    Language = "ar";
  } else {
    Language = "en";
  }
  const messages = {
    ar: ArabicMessages,
    en: EnglishMessages,
  };

  return (
    <HelmetProvider>
      <IntlProvider
        locale={Language}
        messages={messages[Language]}
        defaultLocale="en"
      >
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <ChakraProvider theme={customTheme}>
              <Routes>
                <Route>
                  {routes?.map((route) => {
                    return (
                      <Route
                        key={route?.path}
                        path={route?.path}
                        element={route?.component}
                      />
                    );
                  })}
                </Route>
              </Routes>
              <Footer />
            </ChakraProvider>
          </QueryClientProvider>
        </Provider>
      </IntlProvider>
    </HelmetProvider>
  );
}

export default App;
